import { render, staticRenderFns } from "./otherLogin.vue?vue&type=template&id=62bc0ec4&scoped=true"
import script from "./otherLogin.vue?vue&type=script&lang=js"
export * from "./otherLogin.vue?vue&type=script&lang=js"
import style0 from "./otherLogin.vue?vue&type=style&index=0&id=62bc0ec4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bc0ec4",
  null
  
)

export default component.exports